import { pick } from 'lodash/fp';

import config from '@config';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from './utils';

const BASE_PATHNAME = 'flash-interviews';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const update = ({ id, values }) => dataSource.put(`${BASE_PATHNAME}`, { json: { ...values, id } }).json();

  const approve = async ({ id }) => {
    const res = await dataSource.put(`${BASE_PATHNAME}/${id}/approve`).json();
    return res;
  };

  const reject = async ({ id }) => {
    const res = await dataSource.put(`${BASE_PATHNAME}/${id}/reject`).json();
    return res;
  };

  return {
    getList: getDefaultListHandler({
      transformFilter: pick(['eventIdWa', 'eventId', 'status']),
      url: BASE_PATHNAME,
      dataSource,
    }),

    update,

    approve,

    reject,

    getEmptyList: getDefaultEmptyList,
  };
};
